import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { ButtonWithIcon } from '@els/els-react--button';
import * as WindowHelper from '@Services/WindowHelper';
import { useTargetMode } from '../../TargetModeContext';

import './SidebarPanel.scss';

function SidebarPanel({ isSidebarCollapsed, setSidebarCollapsed, children }) {
  const { active: isTargetModeActive } = useTargetMode();
  const toggleSidebarCollapsed = () => {
    setSidebarCollapsed(!isSidebarCollapsed);
  };

  useEffect(() => {
    const handleResize = () => {
      if (WindowHelper.isTabletView()) {
        setSidebarCollapsed(true);
      } else {
        setSidebarCollapsed(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <aside
      className={cn('advanced-search query-builder-sidebar-panel', {
        'advanced-search--collapsed query-builder-sidebar-panel--collapsed': isSidebarCollapsed,
      })}
      aria-label="Query Builder Search Properties"
      inert={isTargetModeActive ? '' : undefined}>
      {isSidebarCollapsed ? (
        <div className="query-builder-sidebar-panel__collapse-button-container">
          <ButtonWithIcon type="link" sprite="Rewind" data-e2e="querybuilder-opensidebar-button" iconOnly onClick={toggleSidebarCollapsed}>
            Open Panel
          </ButtonWithIcon>
        </div>
      ) : (
        <>
          <div className="query-builder-sidebar-panel__collapse-button-container">
            <ButtonWithIcon
              type="link"
              sprite="FastForward"
              data-e2e="querybuilder-closesidebar-button"
              iconRight
              onClick={toggleSidebarCollapsed}>
              Close Panel
            </ButtonWithIcon>
          </div>
          {children}
        </>
      )}
    </aside>
  );
}

SidebarPanel.propTypes = {
  isSidebarCollapsed: PropTypes.bool,
  setSidebarCollapsed: PropTypes.func,
  children: PropTypes.node,
};

export default SidebarPanel;
